import {computed, decorate, observable} from 'mobx';
import {faSparkles} from '@fortawesome/pro-solid-svg-icons';
import {BaseModel} from './base';

export class CustomAction extends BaseModel {
  static faIcon = faSparkles;

  searchableProperties = ['name', 'method', 'type'];

  saveableProperties = ['name', 'execOrder', 'params', 'url', 'method', 'type', 'params', 'additionalHeaders']

  get paramsFormatted() {
    return this.params ? JSON.stringify(this.params) : null;
  }

  get additionalHeadersFormatted() {
    return this.additionalHeaders ? JSON.stringify(this.additionalHeaders) : null;
  }
}

decorate(CustomAction, {
  id: observable,
  name: observable,
  execOrder: observable,
  params: observable,
  paramsFormatted: computed,
  url: observable,
  additionalHeaders: observable,
  additionalHeadersFormatted: computed,
  method: observable,
  type: observable,
  transitions: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
});
